import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "../services/user.service";
import { NotificationsService } from "angular2-notifications";

@Component({
  selector: 'app-generate-password',
  templateUrl: './generate-password.component.html',
  styleUrls: ['./generate-password.component.css']
})
export class GeneratePasswordComponent implements OnInit {

  constructor(private actroute: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    private notifyService: NotificationsService) { }
  resetPassword = {
    userid: '',
    password: '',
    confirmpassword: '',
    _csrf: null
  };
  submit: boolean;
  navstatus = false;
  errorObj = {
    password: '',
    confirmpassword: '',

  };
  ngOnInit() {
    this.resetPassword.userid = this.actroute.snapshot.paramMap.get('id');
    this.userService.csrf().subscribe((response) => {
      this.resetPassword._csrf = response._csrf;
      this.userService.checkPasswordLink(this.resetPassword).subscribe((response) => {
        if (response.result == true) {
          this.navstatus = true;
        }
      }, (err) => {
        this.notifyService.error("", err.error.message,
          {
            timeOut: 5000,
            showProgressBar: true,
            pauseOnHover: true,
            clickToClose: true,
            maxLength: 50
          }
        )
      })
    }, (err) => {
      this.notifyService.error("", err.error.message,
        {
          timeOut: 5000,
          showProgressBar: true,
          pauseOnHover: true,
          clickToClose: true,
          maxLength: 50
        }
      )
    })
  }
  /**
   * reset password api
   */
  Reset() {
    this.submit = true;
    if (JSON.stringify(this.resetPassword).search('""') != -1) {
      return false
    } else {
      this.userService.setPassword(this.resetPassword).subscribe((response) => {
        this.notifyService.success('', response.message,
          {
            timeOut: 5000,
            showProgressBar: true,
            pauseOnHover: true,
            clickToClose: true,
            maxLength: 50
          }
        );
        setTimeout(() => {
          this.router.navigateByUrl('/index');
        }, 1000)

      }, (err) => {
        this.notifyService.error("", err.error.message,
          {
            timeOut: 5000,
            showProgressBar: true,
            pauseOnHover: true,
            clickToClose: true,
            maxLength: 50
          }
        )
      });
    }
  }
  checkpassword(val, flag) {
    // console.log(val,'dd')
    var strongRegex = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$", "g");
    if (this.resetPassword.password === '') {
      console.log('empty');

      this.clearError('password');
    }
    else if (/\s/.test(val)) {

      this.errorObj.password = 'Do not use whitespace';

    }
    else if (strongRegex.test(val)) {
      // this.errorObj.password = 'Password is Strong';
    }

    else {
      this.errorObj.password = 'Password is Weak';
    }


  }
  /**
   * 
   * @param field 
   */
  clearError(field) {
    switch (field) {
      case 'password':
        this.errorObj.password = '';
        break;
      case 'confirmpassword':
        this.errorObj.confirmpassword = '';
        break;
    }
  }
  /**
   * back to the url
   */
  back() {
    this.router.navigateByUrl('/');

  }
}



// WEBPACK FOOTER //
// ./src/app/generate-password/generate-password.component.ts